import { composeIO } from 'react-compose-io'
import { controleDebitosIO } from './ControleDebitos.IO'
import { ControleDebitosView } from './ControleDebitos.View'

export const ControleDebitos = composeIO(ControleDebitosView, controleDebitosIO)
